import React, { useState, useEffect, useRef } from 'react';
import FeatherIcon from 'feather-icons-react';
import { Modal, Form, Input, Row, Col, Select, message } from 'antd';
import PropTypes from 'prop-types';
import ConfirmationPopup from './ConfirmationPopup'
import AllCancelPopup from './AllCancelPopup';
import { AddUser } from '../style';
import { BasicFormWrapper } from '../../styled';
import { NotesDetailData, deleteNoteId, NoteSave, NoteUpdate } from "../../../Api/Services/NotesapiServices"
import { FetchAllLead, LeadDetailData } from '../../../Api/Services/LeadApiServices';
import { FetchAllContact, FetchContactDetails } from '../../../Api/Services/ContactApiService';
import { FetchAllAccount, FetchAccountDetails, } from '../../../Api/Services/AccountApiService';
import { FetchAllDeal, FetchDealDetails } from "../../../Api/Services/DealApiService"
import { AllTaskList, TaskDeatailsApi } from "../../../Api/Services/TaskapiService"
import { Button } from '../../../components/buttons/buttons';
import { validateShortText, validateDescriptionField } from '../../../components/utilities/utilities';

const { Option } = Select;

const Popup = ({ setNotePopup, notePopup, popupType, UrlId, noteValue, AllNotes, setNaCTrigger, page }) => {
    // const history = useHistory();
    const [form] = Form.useForm();
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [noteTitle, setNoteTitle] = useState()
    const [noteDescription, setNoteDescription] = useState()
    const [relatedTo, setRelatedTo] = useState([])
    const [noteType, setNoteType] = useState()
    const [noteRelatedTo, setNoteRelatedTo] = useState()
    const [confirmPopup, setConfirmPopup] = useState(false)
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const [deleteId, setDeleteId] = useState()
    const [displayDatas, setDisplayDatas] = useState()
    const handleClose = () => {
        setNotePopup(false);
    }
    const handleTypeChange = async (value) => {
        setNoteType(value)
        setNoteRelatedTo()
        if (value === "Account") {
            const allAccounts = await FetchAllAccount()
            const accountMap = new Map(allAccounts.map(item => [item.account_id, item]));
            if (displayDatas?.relatedTo === "Account") {
                const relatedToIdString = displayDatas?.relatedId || "";
                const relatedIds = relatedToIdString
                    .split(',')
                    .map(id => Number(id))
                const missingIds = relatedIds.filter(id => !accountMap.has(id));
                if (missingIds.length > 0) {
                    const missingAccounts = await Promise.all(
                        missingIds.map(async (id) => {
                            try {
                                const responseData = await FetchAccountDetails(id);
                                const account = responseData.data
                                return account?.account_id ? account : null;
                            } catch (error) {
                                message.error(error)
                                return null;
                            }
                        })
                    );
                    missingAccounts.filter(account => account !== null).forEach(account => { accountMap.set(account.account_id, account); });
                }
            }
            const fullAccountList = Array.from(accountMap.values());
            const filterData = fullAccountList.map((option, i) => (
                <Option value={option.account_id} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.account_name} (${option.account_number})`}>
                        {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                            < img src={option.account_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                            :
                            <span className='details_span_Tag AccountIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                {option.account_name.slice(0, 1).toUpperCase()}
                            </span>
                        }
                        <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                    </div>)}>
                    <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                        <div>
                            {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.account_name.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                            <p style={{ margin: 0 }}>{option.account_number}</p>
                        </div>
                    </div>
                </Option>));
            setRelatedTo(filterData)
        }
        else if (value === "Lead") {
            const allAccounts = await FetchAllLead()
            const accountMap = new Map(allAccounts.map(item => [item.leads_id, item]));
            if (displayDatas?.relatedTo === "Lead") {
                const relatedToIdString = displayDatas?.relatedId || "";
                const relatedIds = relatedToIdString
                    .split(',')
                    .map(id => Number(id))
                const missingIds = relatedIds.filter(id => !accountMap.has(id));
                if (missingIds.length > 0) {
                    const missingAccounts = await Promise.all(
                        missingIds.map(async (id) => {
                            try {
                                const responseData = await LeadDetailData(id);
                                const account = responseData.data
                                return account?.leads_id ? account : null;
                            } catch (error) {
                                message.error(error)
                                return null;
                            }
                        })
                    );
                    missingAccounts.filter(account => account !== null).forEach(account => { accountMap.set(account.leads_id, account); });
                }
            }
            const fullAccountList = Array.from(accountMap.values());
            const options = fullAccountList.map((option, i) => (
                <Option value={option.leads_id} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.first_name} ${option.last_name} (${option.primary_email})`}>
                        {option.lead_profile !== null && option.lead_profile !== undefined && option.lead_profile !== "" ?
                            < img src={option.lead_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                            :
                            <span className='details_span_Tag LeadIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                {option.first_name.slice(0, 1).toUpperCase()}
                            </span>
                        }
                        <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                    </div>)} >
                    <div className='UserList-dropdown' title={`${option.first_name} ${option.last_name} (${option.primary_email})`}>
                        <div>
                            {option.lead_profile !== null && option.lead_profile !== undefined && option.lead_profile !== "" ?
                                < img src={option.lead_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag LeadIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.first_name.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                            <p style={{ margin: 0 }}>{option.primary_email}</p>
                        </div>
                    </div>
                </Option>));
            setRelatedTo(options)
        }
        else if (value === "Contact") {
            const allAccounts = await FetchAllContact()
            const accountMap = new Map(allAccounts.map(item => [item.contacts_id, item]));
            if (displayDatas?.relatedTo === "Contact") {
                const relatedToIdString = displayDatas?.relatedId || "";
                const relatedIds = relatedToIdString
                    .split(',')
                    .map(id => Number(id))
                const missingIds = relatedIds.filter(id => !accountMap.has(id));
                if (missingIds.length > 0) {
                    const missingAccounts = await Promise.all(
                        missingIds.map(async (id) => {
                            try {
                                const responseData = await FetchContactDetails(id);
                                const account = responseData.data
                                return account?.contacts_id ? account : null;
                            } catch (error) {
                                message.error(error)
                                return null;
                            }
                        })
                    );
                    missingAccounts.filter(account => account !== null).forEach(account => { accountMap.set(account.contacts_id, account); });
                }
            }
            const fullAccountList = Array.from(accountMap.values());
            const options = fullAccountList.map((option, i) => (
                <Option value={option.contacts_id} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.first_name} ${option.last_name} (${option.email})`}>
                        {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                            < img src={option.contact_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                            :
                            <span className='details_span_Tag ContactIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                {option.first_name.slice(0, 1).toUpperCase()}
                            </span>
                        }
                        <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                    </div>)} >
                    <div className='UserList-dropdown' title={`${option.first_name} ${option.last_name} (${option.email})`}>
                        <div>
                            {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                < img src={option.contact_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag ContactIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.first_name.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                            <p style={{ margin: 0 }}>{option.email}</p>
                        </div>
                    </div>
                </Option>));
            setRelatedTo(options)
        }
        else if (value === "Deal") {
            const allAccounts = await FetchAllDeal()
            const accountMap = new Map(allAccounts.map(item => [item.deals_id, item]));
            if (displayDatas?.relatedTo === "Deal") {
                const relatedToIdString = displayDatas?.relatedId || "";
                const relatedIds = relatedToIdString
                    .split(',')
                    .map(id => Number(id))
                const missingIds = relatedIds.filter(id => !accountMap.has(id));
                if (missingIds.length > 0) {
                    const missingAccounts = await Promise.all(
                        missingIds.map(async (id) => {
                            try {
                                const dealresponse = await FetchDealDetails(id);
                                const account = dealresponse.data
                                return account?.deals_id ? account : null;
                            } catch (error) {
                                message.error(error)
                                return null;
                            }
                        })
                    );
                    missingAccounts.filter(account => account !== null).forEach(account => { accountMap.set(account.deals_id, account); });
                }
            }
            const fullAccountList = Array.from(accountMap.values());
            const options = fullAccountList.map((option, i) => (
                <Option value={option.deals_id} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.deal_name} (${option.pipelineStage})`}>
                        {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                            < img src={option.deal_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                            :
                            <span className='details_span_Tag DealIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                {option.deal_name.slice(0, 1).toUpperCase()}
                            </span>
                        }
                        <p style={{ fontWeight: 'bold', margin: 0 }}>{option.deal_name}</p>
                    </div>)}>
                    <div className='UserList-dropdown' title={`${option.deal_name} (${option.pipelineStage})`}>
                        <div>
                            {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                                < img src={option.deal_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag DealIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.deal_name.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.deal_name}</p>
                            <p style={{ margin: 0 }}>{option.pipelineStage}</p>
                        </div>
                    </div>
                </Option>));
            setRelatedTo(options)
        }
        else if (value === "Task") {
            const allAccounts = await AllTaskList()
            const accountMap = new Map(allAccounts.map(item => [item.task_id, item]));
            if (displayDatas?.relatedTo === "Task") {
                const relatedToIdString = displayDatas?.relatedId || "";
                const relatedIds = relatedToIdString
                    .split(',')
                    .map(id => Number(id))
                const missingIds = relatedIds.filter(id => !accountMap.has(id));
                if (missingIds.length > 0) {
                    const missingAccounts = await Promise.all(
                        missingIds.map(async (id) => {
                            try {
                                const account = await TaskDeatailsApi(id);
                                return account?.data.task_id ? account.data : null;
                            } catch (error) {
                                message.error(error)
                                return null;
                            }
                        })
                    );
                    missingAccounts.filter(account => account !== null).forEach(account => { accountMap.set(account.task_id, account); });
                }
            }
            const fullAccountList = Array.from(accountMap.values());
            const options = fullAccountList.map((option, i) => (
                <Option value={option.task_id} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.task_name} (${option.task_status_name})`}>
                        {option.task_profile !== null && option.task_profile !== undefined && option.task_profile !== "" ?
                            < img src={option.task_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                            :
                            <span className='details_span_Tag TaskIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                {option.task_name.slice(0, 1).toUpperCase()}
                            </span>
                        }
                        <p style={{ fontWeight: 'bold', margin: 0 }}>{option.task_name}</p>
                    </div>)}>
                    <div className='UserList-dropdown' title={`${option.task_name} (${option.task_status_name})`}>
                        <div>
                            {option.task_profile !== null && option.task_profile !== undefined && option.task_profile !== "" ?
                                < img src={option.task_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag TaskIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.task_name.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.task_name}</p>
                            <p style={{ margin: 0 }}>{option.task_status_name}</p>
                        </div>
                    </div>
                </Option>));
            setRelatedTo(options)
        }
    }
    const handleRelatedToChange = (value) => {
        setNoteRelatedTo(value)
    }
    useEffect(() => {
        if (popupType === "Create") {
            if (page !== "Global" && page !== "NotesPage") {
                if (UrlId !== undefined && UrlId !== null && UrlId[0] !== '') {
                    if (UrlId[0] === "?LEAD") {
                        handleTypeChange("Lead")
                    }
                    else if (UrlId[0] === "?CONTACT") {
                        handleTypeChange("Contact")
                    }
                    else if (UrlId[0] === "?ACCOUNT") {
                        handleTypeChange("Account")
                    }
                    else if (UrlId[0] === "?DEAL") {
                        handleTypeChange("Deal")
                    }
                    else if (UrlId[0] === "?TASK") {
                        handleTypeChange("Task")
                    }
                    setNoteRelatedTo([UrlId[1] * 1])
                }
            }
            else {
                handleTypeChange()
                setNoteType("Personal")
            }
            setNoteTitle()
            setNoteDescription()
        }
    }, [])
    const onSubmit = async () => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        const formData =
        {
            noteTittle: noteTitle && noteTitle !== "" ? noteTitle : "Untitled",
            noteDesc: noteDescription && noteDescription !== "" ? noteDescription : "Note Description",
            relatedTo: noteType,
        }
        if (noteType !== "Personal") {
            if (!noteRelatedTo || noteRelatedTo.length === 0) {
                message.error("Please select a relatedTo"); // Display an error message
                return; // Stop the function execution
            }
            const noteRelatedTO = noteRelatedTo.join(',')
            formData.relatedId = noteRelatedTO;
        }
        if (popupType === "Create") {
            const response = await NoteSave(formData)
            if (response.status === 201) {
                message.success("Note created")
                if (page !== "Global" && page !== "NotesPage") {
                    setNaCTrigger("CallBack")
                }
                else {
                    AllNotes()
                }
                setNotePopup(false)
                loadingRef.current = false;
                setDelteClick(false)
            }
        } else {
            const response = await NoteUpdate(formData, noteValue);
            if (response.status === 200) {
                message.success("Note updated")
                AllNotes()
                setNotePopup(false)
                if (page !== "Global" && page !== "NotesPage") {
                    setNaCTrigger("CallBack")
                }
                loadingRef.current = false;
                setDelteClick(false)
            }
        }
    }
    const setData = (value) => {
        if (value !== undefined) {
            setNoteTitle(value.noteTittle)
            setNoteDescription(value.noteDesc)
            setNoteType(value.relatedTo)
            handleTypeChange(value.relatedTo)
            setNoteRelatedTo(value.relatedId && value.relatedId.split(",").map(user => user * 1))
            setDisplayDatas(value)
        }
    }
    const getNotesDetails = async () => {
        try {
            const response = await NotesDetailData(noteValue);
            setData(response);
        }
        catch (error) {
            message.error(error)
        }
    }
    useEffect(() => {
        if (popupType !== "Create") {
            if (noteValue) {
                getNotesDetails()
            }
        }
    }, [noteValue])
    const handleDelete = async (id) => {
        try {
            const response = await deleteNoteId(id);
            if (response.status === 200) {
                setConfirmPopup(false)
                message.success("Note deleted")
                AllNotes()
                setNotePopup(!notePopup)
                if (page !== "Global" && page !== "NotesPage") {
                    setNaCTrigger("CallBack")
                }
            }
        }
        catch (error) {
            message.error(error)
        }
    }
    const OnClickofDelete = (value) => {
        setConfirmPopup(true)
        setDeleteId(value)
    }
    const PageCancel1 = () => {
        if (popupType === "Update") {
            handleClose()
        }
        else {
            setCancelConfirmOpen(true)
        }
    }
    return (
        <>
            <Modal
                title={
                    popupType === "Update" ?
                        <span>
                            Update Notes
                            {noteTitle && (
                                <>
                                    <span style={{ 
                                        margin: '0 10px', 
                                        color: '#d9d9d9', 
                                        fontWeight: 'normal' 
                                    }}>|</span>
                                    <span style={{ fontWeight: 'normal' }}>
                                        {noteTitle}
                                    </span>
                                </>
                            )}
                        </span>
                        : "Create Notes"
                }
                open={notePopup}
                onCancel={PageCancel1}
                maskClosable={false}
                width={700}
                footer={[
                    <div>
                        {popupType === "Update" ?
                            <>
                                {/* <Button onClick={PageCancel1} size="small" className="gray-button" >
                                    <FeatherIcon icon="x" />Cancel
                                </Button> */}
                                <Button onClick={() => OnClickofDelete(noteValue)} size="small" className="red-button" >
                                    <FeatherIcon icon="trash-2" />Delete
                                </Button>
                                <Button className='btn-add_new button_colors' size="small"
                                    onClick={onSubmit} loading={deleteClick} disabled={deleteClick}
                                >
                                    {!deleteClick && <FeatherIcon icon="save" />}Update
                                </Button>
                            </>
                            :
                            <>
                                {/* <Button onClick={PageCancel1} className="gray-button" size="small" >
                                    <FeatherIcon icon="x" />Cancel
                                </Button> */}
                                <Button className='btn-add_new button_colors' size="small"
                                    onClick={onSubmit} loading={deleteClick} disabled={deleteClick}
                                >
                                    {!deleteClick && <FeatherIcon icon="save" />}Save
                                </Button>
                            </>}
                    </div>
                ]}
            >
                <AddUser>
                    <div className="user-info-form">
                        <BasicFormWrapper>
                            <Form style={{ width: '100%' }} form={form} name="AddNotes" colon={false}>
                                <Row gutter={30} style={{ padding: "0px 20px" }}>
                                    <Col span={24} style={{ marginBottom: 10 }}>
                                        <Form.Item label="Title">
                                            <Input value={noteTitle}
                                                onChange={(e) => {
                                                    const inputValue = e.target.value;
                                                    const error = validateShortText(inputValue, 50);
                                                    if (error) {
                                                        message.error(error);
                                                        return;
                                                    }
                                                    setNoteTitle(inputValue);
                                                }} placeholder="Untitled"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault(); // Prevent default behavior like form submission
                                                        onSubmit(); // Call the submit function
                                                    }
                                                }} />
                                        </Form.Item>
                                    </Col>
                                    {(page !== "Global" && page !== "Entity") &&
                                        <>
                                            < Col span={24} style={{ marginBottom: 10 }}>
                                                <Form.Item label="Type">
                                                    <Select style={{ width: '100%' }}
                                                        placeholder="Select Type"
                                                        value={noteType}
                                                        onChange={handleTypeChange}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                e.preventDefault(); // Prevent default behavior like form submission
                                                                onSubmit(); // Call the submit function
                                                            }
                                                        }}
                                                    >
                                                        <Option value="Personal">Personal</Option>
                                                        <Option value="Lead">Lead</Option>
                                                        <Option value="Contact">Contact</Option>
                                                        <Option value="Account">Account</Option>
                                                        <Option value="Deal">Deal</Option>
                                                        <Option value="Task">Task</Option>
                                                        {/* <Option value="Meeting">Meeting</Option> */}
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            {noteType !== null && noteType !== "Personal" &&
                                                <Col span={24} style={{ marginBottom: 10 }}>
                                                    <Form.Item label="Related to">
                                                        <Select style={{ width: '100%' }} showSearch
                                                            optionFilterProp="children"
                                                            filterOption={(input, option) => {
                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                    const username = String(usernameElement.props.children);
                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                }
                                                                return false;
                                                            }
                                                            } mode="multiple" optionLabelProp="label"
                                                            value={noteRelatedTo}
                                                            onChange={handleRelatedToChange}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter') {
                                                                    e.preventDefault(); // Prevent default behavior like form submission
                                                                    onSubmit(); // Call the submit function
                                                                }
                                                            }}
                                                        >
                                                            {relatedTo}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>}
                                        </>
                                    }
                                    <Col span={24} style={{ marginBottom: 10 }}>
                                        <Form.Item label="Description">
                                            <Input.TextArea value={noteDescription}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' && e.shiftKey) {
                                                        e.preventDefault();
                                                        onSubmit();
                                                    }
                                                }} rows={3} maxLength={2500} showCount placeholder='Enter Description'
                                                onChange={(e) => {
                                                    const inputValue = e.target.value;
                                                    const error = validateDescriptionField(inputValue, 2500);
                                                    if (error) {
                                                        message.error(error);
                                                        return;
                                                    }
                                                    setNoteDescription(inputValue);
                                                }} />
                                        </Form.Item>
                                    </Col>

                                </Row>
                            </Form>
                        </BasicFormWrapper>
                    </div>
                </AddUser>
            </Modal >
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={handleClose} />}
            {confirmPopup && <ConfirmationPopup confirmPopup={confirmPopup} setConfirmPopup={setConfirmPopup} GetCallback={handleDelete} deleteId={deleteId} />}
        </>
    );
};

Popup.propTypes = {
    notePopup: PropTypes.bool.isRequired,
    setNotePopup: PropTypes.func.isRequired,
    popupType: PropTypes.string.isRequired,
    UrlId: PropTypes.array.isRequired,
    noteValue: PropTypes.number.isRequired,
    AllNotes: PropTypes.func.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    page: PropTypes.string.isRequired,
};

export default Popup;